import { LegacyMigrationMessages, TranslationLegacyMigrationMessages } from "./interfaces";

export const messages: TranslationLegacyMigrationMessages = {
  [LegacyMigrationMessages.legacyMigrationTitle]: "Migração do legado",
  [LegacyMigrationMessages.legacyMigrationNotConfigured]:
    "A migração não está configurada neste ambiente. {{problem}}",
  [LegacyMigrationMessages.legacyMigrationForbidden]:
    "Você não tem acesso à migração do legado. Peça a quem gerencia o acesso.",
  [LegacyMigrationMessages.legacyMigrationSessionExpired]:
    "Sua sessão expirou. Entre novamente para continuar.",

  [LegacyMigrationMessages.legacyMigrationStepCustomer]: "Cliente",
  [LegacyMigrationMessages.legacyMigrationStepReview]: "Revisão",

  [LegacyMigrationMessages.legacyMigrationChooseTitle]: "Qual cliente você vai migrar?",
  [LegacyMigrationMessages.legacyMigrationSearchTenant]: "Buscar cliente",
  [LegacyMigrationMessages.legacyMigrationNoTenants]: "Nenhum cliente com esse nome.",
  [LegacyMigrationMessages.legacyMigrationTenantsUnavailable]:
    "Não foi possível carregar a lista de clientes.",
  [LegacyMigrationMessages.legacyMigrationInactiveTenant]: "inativo",
  [LegacyMigrationMessages.legacyMigrationStart]: "Iniciar migração",

  [LegacyMigrationMessages.legacyMigrationReadingTitle]: "Lendo os usuários de {{tenant}}…",
  [LegacyMigrationMessages.legacyMigrationReadingHint]:
    "Estamos lendo a base do CRM antigo. Leva alguns segundos e nada é alterado lá.",

  [LegacyMigrationMessages.legacyMigrationReviewTitle]: "{{count}} usuários de {{tenant}} serão migrados",
  [LegacyMigrationMessages.legacyMigrationSearchUser]: "Buscar e-mail ou nome",
  [LegacyMigrationMessages.legacyMigrationSelectAll]: "Marcar todos",
  [LegacyMigrationMessages.legacyMigrationClearAll]: "Desmarcar todos",
  [LegacyMigrationMessages.legacyMigrationColumnUser]: "Usuário",
  [LegacyMigrationMessages.legacyMigrationColumnPassword]: "Senha",
  [LegacyMigrationMessages.legacyMigrationColumnModules]: "Módulos",
  [LegacyMigrationMessages.legacyMigrationPasswordKept]: "mantém a senha (MAIÚSCULAS)",
  [LegacyMigrationMessages.legacyMigrationPasswordReset]: "vai receber e-mail",
  [LegacyMigrationMessages.legacyMigrationPasswordKeptHint]:
    "No Topcon Suite, a senha deve ser digitada com as letras em MAIÚSCULAS, como o Topcon Legado a guarda.",
  [LegacyMigrationMessages.legacyMigrationPasswordWeakHint]:
    "A senha do Topcon Legado não atende as regras do Topcon Suite (8 a 64 caracteres, com letras, números e símbolo). "
    + "O usuário recebe um e-mail para criar uma nova.",
  [LegacyMigrationMessages.legacyMigrationLockNeedsKeptPassword]:
    "Só dá para bloquear quando a senha do Topcon Legado é mantida. Sem ela, o usuário ficaria sem acesso aos dois sistemas "
    + "até criar a senha pelo e-mail.",
  [LegacyMigrationMessages.legacyMigrationNotContractedBanner]:
    "Não contratado para {{tenant}}: {{modules}}. Contrate no Tenant Manager antes de migrar; quem só tem esse módulo "
    + "não recebe acesso.",
  [LegacyMigrationMessages.legacyMigrationNotContracted]: "não contratado pelo cliente — não será liberado",
  [LegacyMigrationMessages.legacyMigrationIneligibleCount]:
    "{{count}} usuários não podem ser migrados — ver motivos",
  [LegacyMigrationMessages.legacyMigrationBack]: "Voltar",
  [LegacyMigrationMessages.legacyMigrationExportList]: "Exportar lista",
  [LegacyMigrationMessages.legacyMigrationExportListHint]:
    "Planilha com os usuários que podem ser migrados, para o cliente conferir antes da migração.",
  [LegacyMigrationMessages.legacyMigrationExportListEmail]: "E-mail",
  [LegacyMigrationMessages.legacyMigrationExportListStatus]: "Situação",
  [LegacyMigrationMessages.legacyMigrationExportListLockLegacy]: "Bloquear Legado",
  [LegacyMigrationMessages.legacyMigrationExportListNewLegacyPassword]: "Cadastrar nova senha no Legado",
  [LegacyMigrationMessages.legacyMigrationConfirm]: "Migrar {{count}} usuários",
  [LegacyMigrationMessages.legacyMigrationConfirmAction]: "Migrar agora",
  [LegacyMigrationMessages.legacyMigrationConfirmTitle]: "Confirmar a migração de {{tenant}}",
  [LegacyMigrationMessages.legacyMigrationConfirmBody]:
    "{{count}} usuários serão criados no Identity e poderão entrar pelo login da Topcon.",
  [LegacyMigrationMessages.legacyMigrationConfirmPasswords]:
    "{{count}} deles receberão um e-mail para criar a senha. Você pode rodar de novo depois sem duplicar ninguém.",

  [LegacyMigrationMessages.legacyMigrationMigratingTitle]: "Migrando os usuários de {{tenant}}",
  [LegacyMigrationMessages.legacyMigrationMigratingHint]:
    "Mantenha esta tela aberta até o fim. Se fechar, a migração para onde estiver — quem já foi migrado permanece no Identity.",
  [LegacyMigrationMessages.legacyMigrationProgress]: "{{done}} de {{count}} usuários",
  [LegacyMigrationMessages.legacyMigrationErrorsSoFar]: "{{count}} usuários com erro até agora",
  [LegacyMigrationMessages.legacyMigrationStop]: "Parar migração",
  [LegacyMigrationMessages.legacyMigrationStopping]: "Parando…",

  [LegacyMigrationMessages.legacyMigrationDoneTitle]: "Pronto! {{tenant}} foi migrado",
  [LegacyMigrationMessages.legacyMigrationDoneWithErrorsTitle]:
    "{{tenant}} foi migrado, mas alguns usuários falharam",
  [LegacyMigrationMessages.legacyMigrationStoppedTitle]: "A migração de {{tenant}} foi interrompida",
  [LegacyMigrationMessages.legacyMigrationDoneHint]:
    "Senhas mantidas: {{kept}} · E-mails de criação de senha enviados: {{reset}}.",
  [LegacyMigrationMessages.legacyMigrationStatCreated]: "criados",
  [LegacyMigrationMessages.legacyMigrationStatUpdated]: "atualizados",
  [LegacyMigrationMessages.legacyMigrationStatSkipped]: "sem mudança",
  [LegacyMigrationMessages.legacyMigrationStatErrors]: "erros",
  [LegacyMigrationMessages.legacyMigrationExport]: "Exportar CSV",
  [LegacyMigrationMessages.legacyMigrationRetry]: "Rodar novamente",

  // The plural forms i18next picks from the `count` option.
  [LegacyMigrationMessages.legacyMigrationReviewTitleZero]:
    "Nenhum usuário marcado — marque quem deve ser migrado",
  [LegacyMigrationMessages.legacyMigrationReviewTitleOne]:
    "{{count}} usuário de {{tenant}} será migrado",
  [LegacyMigrationMessages.legacyMigrationReviewTitleOther]:
    "{{count}} usuários de {{tenant}} serão migrados",
  [LegacyMigrationMessages.legacyMigrationIneligibleCountOne]:
    "1 usuário não pode ser migrado — ver motivo",
  [LegacyMigrationMessages.legacyMigrationIneligibleCountOther]:
    "{{count}} usuários não podem ser migrados — ver motivos",
  [LegacyMigrationMessages.legacyMigrationConfirmZero]:
    "Nenhum usuário marcado",
  [LegacyMigrationMessages.legacyMigrationConfirmOne]:
    "Migrar 1 usuário",
  [LegacyMigrationMessages.legacyMigrationConfirmOther]:
    "Migrar {{count}} usuários",
  [LegacyMigrationMessages.legacyMigrationConfirmBodyOne]:
    "1 usuário será criado no Identity e poderá entrar pelo login da Topcon.",
  [LegacyMigrationMessages.legacyMigrationConfirmBodyOther]:
    "{{count}} usuários serão criados no Identity e poderão entrar pelo login da Topcon.",
  [LegacyMigrationMessages.legacyMigrationConfirmPasswordsZero]:
    "Todos mantêm a senha do CRM antigo. Você pode rodar de novo depois sem duplicar ninguém.",
  [LegacyMigrationMessages.legacyMigrationConfirmPasswordsOne]:
    "1 deles receberá um e-mail para criar a senha. Você pode rodar de novo depois sem duplicar ninguém.",
  [LegacyMigrationMessages.legacyMigrationConfirmPasswordsOther]:
    "{{count}} deles receberão um e-mail para criar a senha. Você pode rodar de novo depois sem duplicar ninguém.",
  [LegacyMigrationMessages.legacyMigrationProgressOne]:
    "{{done}} de 1 usuário",
  [LegacyMigrationMessages.legacyMigrationProgressOther]:
    "{{done}} de {{count}} usuários",
  [LegacyMigrationMessages.legacyMigrationErrorsSoFarOne]:
    "1 usuário com erro até agora",
  [LegacyMigrationMessages.legacyMigrationErrorsSoFarOther]:
    "{{count}} usuários com erro até agora",

  [LegacyMigrationMessages.legacyMigrationOutcomeCreated]: "Criado",
  [LegacyMigrationMessages.legacyMigrationOutcomeUpdated]: "Atualizado",
  [LegacyMigrationMessages.legacyMigrationOutcomeSkipped]: "Sem mudança",
  [LegacyMigrationMessages.legacyMigrationOutcomeError]: "Erro",

  [LegacyMigrationMessages.legacyMigrationReasonNoEmail]: "Sem e-mail no cadastro do legado.",
  [LegacyMigrationMessages.legacyMigrationReasonNoAccessRows]: "Sem nenhum acesso cadastrado no legado.",
  [LegacyMigrationMessages.legacyMigrationReasonNoSsoAccess]: "Não possui direito no CRM.",
  [LegacyMigrationMessages.legacyMigrationReasonInOtherTenant]: "Já existe no Identity em outro cliente ({{detail}}).",
  [LegacyMigrationMessages.legacyMigrationReasonTopconStaff]: "Conta da equipe Topcon (@topconsuite.com): não é migrada.",
  [LegacyMigrationMessages.legacyMigrationReasonAlreadyProvisioned]: "Já existia no Identity com esses módulos.",
  [LegacyMigrationMessages.legacyMigrationReasonNoModulesSelected]: "Nenhum módulo selecionado.",
  [LegacyMigrationMessages.legacyMigrationReasonRemovedFromSource]:
    "Removido da base legada depois da revisão.",
  [LegacyMigrationMessages.legacyMigrationReasonEmailChanged]:
    "E-mail alterado na base legada depois da revisão (agora {{detail}}).",
  [LegacyMigrationMessages.legacyMigrationReasonResetEmailFailed]:
    "Conta criada, mas o e-mail de redefinição de senha não foi enviado.",
  [LegacyMigrationMessages.legacyMigrationReasonProvisionFailed]: "Falha ao provisionar: {{detail}}",
  [LegacyMigrationMessages.legacyMigrationReasonInvalidEmail]: "E-mail ausente ou inválido.",
  [LegacyMigrationMessages.legacyMigrationReasonNoValidModules]: "Nenhum módulo válido do Identity.",

  [LegacyMigrationMessages.legacyMigrationErrorForbidden]:
    "Você não tem acesso à migração do legado. Peça a quem gerencia o acesso.",
  [LegacyMigrationMessages.legacyMigrationErrorTenantNotFound]: "Cliente não encontrado.",
  [LegacyMigrationMessages.legacyMigrationErrorDataSourceNotConfigured]:
    "O registro das bases legadas não está configurado neste ambiente.",
  [LegacyMigrationMessages.legacyMigrationErrorDataSourceNotFound]:
    "Este cliente não tem base legada cadastrada.",
  [LegacyMigrationMessages.legacyMigrationErrorDataSourceUnavailable]:
    "Não foi possível acessar a base legada.",
  [LegacyMigrationMessages.legacyMigrationErrorModuleNotContracted]:
    "O cliente não contratou todos os módulos selecionados.",
  [LegacyMigrationMessages.legacyMigrationErrorInvalidRequest]: "Requisição inválida.",
  [LegacyMigrationMessages.legacyMigrationErrorUnknown]: "Não foi possível concluir a operação.",
  [LegacyMigrationMessages.legacyMigrationErrorDataSourceAccessDenied]:
    "O usuário do Identity não existe ou não tem permissão na base deste cliente.",

  [LegacyMigrationMessages.legacyMigrationColumnLegacy]: "Legado",
  [LegacyMigrationMessages.legacyMigrationLock]: "bloquear",
  [LegacyMigrationMessages.legacyMigrationLockAll]: "Bloquear o Topcon Legado de todos",
  [LegacyMigrationMessages.legacyMigrationAlsoUses]: "usa também: {{areas}}",
  [LegacyMigrationMessages.legacyMigrationAlreadyLocked]: "já bloqueado",
  [LegacyMigrationMessages.legacyMigrationReviewLockHint]:
    "Em \"Legado\", quem estiver marcado perde a senha do Topcon Legado e passa a entrar só pelo Identity.",
  [LegacyMigrationMessages.legacyMigrationConfirmLocks]:
    "{{count}} perderão a senha do Topcon Legado e passarão a entrar só pelo Identity. Para devolver o acesso, redefina a senha pelo Topcon Legado.",
  [LegacyMigrationMessages.legacyMigrationConfirmLocksOne]:
    "1 perderá a senha do Topcon Legado e passará a entrar só pelo Identity. Para devolver o acesso, redefina a senha pelo Topcon Legado.",
  [LegacyMigrationMessages.legacyMigrationConfirmLocksOther]:
    "{{count}} perderão a senha do Topcon Legado e passarão a entrar só pelo Identity. Para devolver o acesso, redefina a senha pelo Topcon Legado.",
  [LegacyMigrationMessages.legacyMigrationLockedSummary]: "Senhas do Topcon Legado bloqueadas: {{count}}.",
  [LegacyMigrationMessages.legacyMigrationLockFailed]:
    "{{count}} senhas do Topcon Legado não puderam ser bloqueadas — veja o motivo no CSV.",
  [LegacyMigrationMessages.legacyMigrationLockFailedOne]:
    "1 senha do Topcon Legado não pôde ser bloqueada — veja o motivo no CSV.",
  [LegacyMigrationMessages.legacyMigrationLockFailedOther]:
    "{{count}} senhas do Topcon Legado não puderam ser bloqueadas — veja o motivo no CSV.",

  [LegacyMigrationMessages.legacyMigrationLockReasonLocked]: "Senha do Topcon Legado bloqueada.",
  [LegacyMigrationMessages.legacyMigrationLockReasonAlreadyLocked]: "O Topcon Legado já estava bloqueado.",
  [LegacyMigrationMessages.legacyMigrationLockReasonSkippedPasswordNotKept]:
    "Não bloqueado: a senha do Topcon Legado não foi mantida, e o usuário ainda não tem senha no Topcon Suite.",
  [LegacyMigrationMessages.legacyMigrationLockReasonPasswordChanged]:
    "Não bloqueado: a senha foi alterada no Topcon Legado durante a migração.",
  [LegacyMigrationMessages.legacyMigrationLockReasonDenied]:
    "Não bloqueado: o usuário do Identity não tem permissão para alterar senhas nesta base.",
  [LegacyMigrationMessages.legacyMigrationLockReasonFailed]:
    "Não bloqueado: falha ao gravar no Topcon Legado ({{detail}}).",

  [LegacyMigrationMessages.legacyMigrationManageAccess]: "Gerenciar acesso",
  [LegacyMigrationMessages.legacyMigrationAccessTitle]: "Gerenciar acesso",
  [LegacyMigrationMessages.legacyMigrationAccessSubtitle]: "Admins que podem migrar clientes do Topcon Legado para o Identity.",
  [LegacyMigrationMessages.legacyMigrationAccessGrantLabel]: "Adicionar administrador",
  [LegacyMigrationMessages.legacyMigrationAccessGrant]: "Dar acesso",
  [LegacyMigrationMessages.legacyMigrationAccessRevoke]: "Remover acesso",
  [LegacyMigrationMessages.legacyMigrationAccessEmpty]: "Ninguém tem acesso ainda.",
  [LegacyMigrationMessages.legacyMigrationAccessGrantedBy]: "Concedido por {{name}} em {{date}}",
  [LegacyMigrationMessages.legacyMigrationAccessLoading]: "Carregando…",
  [LegacyMigrationMessages.legacyMigrationAccessLoadError]: "Não foi possível verificar o seu acesso.",
  [LegacyMigrationMessages.legacyMigrationTryAgain]: "Tentar novamente",

  [LegacyMigrationMessages.legacyMigrationSelectShown]: "Marcar os {{count}} filtrados",
  [LegacyMigrationMessages.legacyMigrationSelectShownOne]: "Marcar este",
  [LegacyMigrationMessages.legacyMigrationSelectShownOther]: "Marcar os {{count}} filtrados",
  [LegacyMigrationMessages.legacyMigrationClearShown]: "Desmarcar os {{count}} filtrados",
  [LegacyMigrationMessages.legacyMigrationClearShownOne]: "Desmarcar este",
  [LegacyMigrationMessages.legacyMigrationClearShownOther]: "Desmarcar os {{count}} filtrados",
  [LegacyMigrationMessages.legacyMigrationFilterAll]: "Todos",
  [LegacyMigrationMessages.legacyMigrationFilterLeftOut]: "Fora da migração",
  [LegacyMigrationMessages.legacyMigrationFilterOtherAreas]: "Usam outras áreas",
  [LegacyMigrationMessages.legacyMigrationFilterOnlyCrm]: "Só CRM",
  [LegacyMigrationMessages.legacyMigrationNoUsersFound]: "Nenhum usuário encontrado.",
  [LegacyMigrationMessages.legacyMigrationPageRange]: "{{from}}–{{to}} de {{total}}",
  [LegacyMigrationMessages.legacyMigrationPageNext]: "Próxima página",
  [LegacyMigrationMessages.legacyMigrationPagePrevious]: "Página anterior",
  [LegacyMigrationMessages.legacyMigrationPageGoTo]: "Ir para a página {{page}}",

  [LegacyMigrationMessages.legacyMigrationStaffErrorForbidden]: "Você não tem permissão para gerenciar este acesso.",
  [LegacyMigrationMessages.legacyMigrationStaffErrorUserNotFound]: "Usuário não encontrado.",
  [LegacyMigrationMessages.legacyMigrationStaffErrorTargetNotAdmin]: "Só administradores podem receber este acesso.",
  [LegacyMigrationMessages.legacyMigrationStaffErrorCannotRevokeSelf]: "Você não pode remover o seu próprio acesso.",

  [LegacyMigrationMessages.legacyMigrationStepResult]: "Resultado",
  [LegacyMigrationMessages.legacyMigrationInIdentity]: "já no Identity",
  [LegacyMigrationMessages.legacyMigrationInIdentityHint]: "Já existe no Identity. Migrar de novo só adiciona o que faltar.",
  [LegacyMigrationMessages.legacyMigrationFilterInIdentity]: "Já no Identity",
  [LegacyMigrationMessages.legacyMigrationSubtitle]:
    "Traga os usuários do CRM (TopSys) para o Identity. Rodar de novo é seguro: ninguém é duplicado.",
  [LegacyMigrationMessages.legacyMigrationChooseHint]: "{{count}} clientes. Na revisão, quem já está no Identity aparece identificado.",
  [LegacyMigrationMessages.legacyMigrationChooseHintZero]: "Nenhum cliente encontrado.",
  [LegacyMigrationMessages.legacyMigrationChooseHintOne]: "1 cliente. Na revisão, quem já está no Identity aparece identificado.",
  [LegacyMigrationMessages.legacyMigrationChooseHintOther]:
    "{{count}} clientes. Na revisão, quem já está no Identity aparece identificado.",
  [LegacyMigrationMessages.legacyMigrationReviewHint]:
    "Desmarque quem não deve ir; quem já está no Identity começa desmarcado. Quem tem no Topcon Legado uma senha dentro das "
    + "regras do Topcon Suite continua com ela, digitando em MAIÚSCULAS; os demais recebem um e-mail para criar uma nova.",
  [LegacyMigrationMessages.legacyMigrationLeave]: "Voltar ao início",

  // TopconFLEET source
  [LegacyMigrationMessages.legacyMigrationSourceLabel]:
    "Migrar de",
  [LegacyMigrationMessages.legacyMigrationSourceCrm]:
    "CRM (TopSys)",
  [LegacyMigrationMessages.legacyMigrationSourceFleet]:
    "TopconFLEET",
  [LegacyMigrationMessages.legacyMigrationFleetSubtitle]:
    "Traga os usuários do TopconFLEET para o Identity, pela API do FLEET de cada cliente. Rodar de novo é seguro: ninguém é duplicado.",
  [LegacyMigrationMessages.legacyMigrationFleetChooseHint]:
    "{{count}} clientes com o FLEET conectado no Tenant Manager.",
  [LegacyMigrationMessages.legacyMigrationFleetChooseHintZero]:
    "Nenhum cliente com o FLEET conectado no Tenant Manager (URL e token do FLEET).",
  [LegacyMigrationMessages.legacyMigrationFleetChooseHintOne]:
    "1 cliente com o FLEET conectado no Tenant Manager.",
  [LegacyMigrationMessages.legacyMigrationFleetChooseHintOther]:
    "{{count}} clientes com o FLEET conectado no Tenant Manager.",
  [LegacyMigrationMessages.legacyMigrationFleetNotContracted]:
    "FLEET não contratado",
  [LegacyMigrationMessages.legacyMigrationFleetNotContractedHint]:
    "O FLEET não está contratado em Modules / Products deste cliente: a revisão abre, mas ninguém recebe o acesso até contratar.",
  [LegacyMigrationMessages.legacyMigrationFleetReadingHint]:
    "Estamos lendo os usuários pela API do FLEET deste cliente. Leva alguns segundos e nada é alterado lá.",
  [LegacyMigrationMessages.legacyMigrationFleetReviewHint]:
    "Desmarque quem não deve ir; quem já está no Identity começa desmarcado. O FLEET guarda a senha criptografada, então "
    + "ela não é levada: cada usuário novo recebe um e-mail para criar a senha do Topcon Suite. Perfis e permissões continuam "
    + "no FLEET.",
  [LegacyMigrationMessages.legacyMigrationFleetReviewLockHint]:
    "Em \"FLEET\", quem estiver marcado perde a senha do FLEET e passa a entrar só pelo Identity. Só vale para quem já tem senha no Topcon Suite.",
  [LegacyMigrationMessages.legacyMigrationFleetPasswordHint]:
    "A senha do FLEET é criptografada e não pode ser levada: o usuário recebe um e-mail para criar a senha do Topcon Suite.",
  [LegacyMigrationMessages.legacyMigrationFleetLockNeedsSignIn]:
    "Só dá para bloquear quem já tem senha no Topcon Suite. Os demais continuam com a senha do FLEET até criarem a nova; "
    + "rode a migração de novo depois para bloquear.",
  [LegacyMigrationMessages.legacyMigrationFleetAdmin]:
    "admin no FLEET",
  [LegacyMigrationMessages.legacyMigrationFleetAdminHint]:
    "Continua admin no FLEET. No Identity, entra como usuário comum.",
  [LegacyMigrationMessages.legacyMigrationFleetSignedIn]:
    "já entra pelo Identity",
  [LegacyMigrationMessages.legacyMigrationFleetColumnLegacy]:
    "FLEET",
  [LegacyMigrationMessages.legacyMigrationFleetLockAll]:
    "Bloquear a senha do FLEET de todos",
  [LegacyMigrationMessages.legacyMigrationFleetExportListLockLegacy]:
    "Bloquear FLEET",
  [LegacyMigrationMessages.legacyMigrationFleetExportListNewPassword]:
    "Receberá e-mail para criar a senha",
  [LegacyMigrationMessages.legacyMigrationFleetConfirmLocks]:
    "{{count}} perderão a senha do FLEET e passarão a entrar só pelo Identity. Para devolver o acesso, defina uma nova "
    + "senha no cadastro do usuário no FLEET.",
  [LegacyMigrationMessages.legacyMigrationFleetConfirmLocksOne]:
    "1 perderá a senha do FLEET e passará a entrar só pelo Identity. Para devolver o acesso, defina uma nova senha no cadastro do usuário no FLEET.",
  [LegacyMigrationMessages.legacyMigrationFleetConfirmLocksOther]:
    "{{count}} perderão a senha do FLEET e passarão a entrar só pelo Identity. Para devolver o acesso, defina uma nova "
    + "senha no cadastro do usuário no FLEET.",
  [LegacyMigrationMessages.legacyMigrationFleetLockedSummary]:
    "Senhas do FLEET bloqueadas: {{count}}.",
  [LegacyMigrationMessages.legacyMigrationFleetLockFailed]:
    "{{count}} senhas do FLEET não foram bloqueadas — veja o motivo no CSV.",
  [LegacyMigrationMessages.legacyMigrationFleetLockFailedOne]:
    "1 senha do FLEET não foi bloqueada — veja o motivo no CSV.",
  [LegacyMigrationMessages.legacyMigrationFleetLockFailedOther]:
    "{{count}} senhas do FLEET não foram bloqueadas — veja o motivo no CSV.",
  [LegacyMigrationMessages.legacyMigrationFleetLockReasonLocked]:
    "Senha do FLEET bloqueada.",
  [LegacyMigrationMessages.legacyMigrationFleetLockReasonSkippedPasswordNotKept]:
    "Não bloqueado: o usuário ainda não criou a senha do Topcon Suite. Rode a migração de novo depois que ele entrar pelo Identity.",
  [LegacyMigrationMessages.legacyMigrationFleetLockReasonDenied]:
    "Não bloqueado: o FLEET recusou o token de integração.",
  [LegacyMigrationMessages.legacyMigrationFleetLockReasonFailed]:
    "Não bloqueado: falha ao gravar no FLEET (HTTP {{detail}}).",
  [LegacyMigrationMessages.legacyMigrationLockReasonUserGone]:
    "Não bloqueado: o usuário não existe mais no sistema legado.",
  [LegacyMigrationMessages.legacyMigrationReasonFleetSuperAdmin]:
    "Super admin do FLEET (conta da Topcon): não é migrado.",
  [LegacyMigrationMessages.legacyMigrationReasonFleetInactive]:
    "Inativo no FLEET.",
  [LegacyMigrationMessages.legacyMigrationErrorFleetNotConfigured]:
    "Este cliente não tem a URL e o token do FLEET no Tenant Manager.",
  [LegacyMigrationMessages.legacyMigrationErrorFleetUnavailable]:
    "Não foi possível acessar a API do FLEET deste cliente.",
  [LegacyMigrationMessages.legacyMigrationErrorFleetTokenRejected]:
    "O FLEET deste cliente recusou o token de integração. Confira o token no Tenant Manager.",
  [LegacyMigrationMessages.legacyMigrationErrorFleetOutdated]:
    "O FLEET deste cliente ainda não tem a versão com a migração de usuários. Atualize o FLEET do cliente.",

  // Screen clarity,
  [LegacyMigrationMessages.legacyMigrationErrorFleetCorporateSso]:
    "Este cliente entra no FLEET pelo login Microsoft da própria empresa (SSO corporativo). O Identity ainda não "
    + "oferece esse login, então a migração não está disponível para ele.",
  [LegacyMigrationMessages.legacyMigrationLockCalloutTitle]:
    "Bloqueio da senha do Topcon Legado",
  [LegacyMigrationMessages.legacyMigrationFleetLockCalloutTitle]:
    "Bloqueio da senha do FLEET (coluna \"FLEET\")",
  [LegacyMigrationMessages.legacyMigrationLockHelp]:
    "Marcado: depois de migrar, a senha do Topcon Legado é trocada por uma que ninguém conhece e o usuário passa a entrar só pelo Identity.",
  [LegacyMigrationMessages.legacyMigrationFleetLockHelp]:
    "Marcado: depois de migrar, a senha do FLEET é trocada por uma que ninguém conhece e o usuário passa a entrar no FLEET só pelo Identity.",
  [LegacyMigrationMessages.legacyMigrationFleetSignedInHint]:
    "Já entrou no FLEET pelo login da Topcon: tem senha no Topcon Suite, então a senha do FLEET já pode ser bloqueada.",
  [LegacyMigrationMessages.legacyMigrationConfirmEmails]:
    "{{count}} receberão um e-mail para criar a senha.",
  [LegacyMigrationMessages.legacyMigrationConfirmEmailsZero]:
    "Ninguém recebe e-mail: todos mantêm a senha do Topcon Legado ou já estão no Identity.",
  [LegacyMigrationMessages.legacyMigrationConfirmEmailsOne]:
    "1 receberá um e-mail para criar a senha.",
  [LegacyMigrationMessages.legacyMigrationConfirmEmailsOther]:
    "{{count}} receberão um e-mail para criar a senha.",
  [LegacyMigrationMessages.legacyMigrationFleetConfirmEmails]:
    "{{count}} receberão um e-mail para criar a senha do Topcon Suite (a senha do FLEET não é levada).",
  [LegacyMigrationMessages.legacyMigrationFleetConfirmEmailsZero]:
    "Ninguém recebe e-mail: todos já estão no Identity e continuam com a senha que já têm.",
  [LegacyMigrationMessages.legacyMigrationFleetConfirmEmailsOne]:
    "1 receberá um e-mail para criar a senha do Topcon Suite (a senha do FLEET não é levada).",
  [LegacyMigrationMessages.legacyMigrationFleetConfirmEmailsOther]:
    "{{count}} receberão um e-mail para criar a senha do Topcon Suite (a senha do FLEET não é levada).",
  [LegacyMigrationMessages.legacyMigrationConfirmRerun]:
    "Você pode rodar de novo depois sem duplicar ninguém.",
  [LegacyMigrationMessages.legacyMigrationFleetDoneHint]:
    "E-mails de criação de senha enviados: {{reset}}.",
  [LegacyMigrationMessages.legacyMigrationResultTitle]:
    "Resultado por usuário",
  [LegacyMigrationMessages.legacyMigrationResultOnlyProblems]:
    "Só erros e pendências",
  [LegacyMigrationMessages.legacyMigrationColumnResult]:
    "Resultado",
  [LegacyMigrationMessages.legacyMigrationColumnDetail]:
    "Detalhe",
  [LegacyMigrationMessages.legacyMigrationResultPasswordKept]:
    "senha mantida",
  [LegacyMigrationMessages.legacyMigrationResultEmailSent]:
    "e-mail enviado",
  [LegacyMigrationMessages.legacyMigrationResultLockNotAsked]:
    "não pedido"
};
